import { useEffect, useState } from "react";
import { Reveal } from "./Reveal";
import { Mandala, Vine } from "../HennaMotif";

const TARGET = new Date("2026-11-15T19:00:00+03:00").getTime();

const calc = () => {
  const diff = Math.max(0, TARGET - Date.now());
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
};

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = () => {
  const [t, setT] = useState(calc());

  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { key: "days", value: t.d, label: "Gün", testid: "countdown-days" },
    { key: "hours", value: pad(t.h), label: "Saat", testid: "countdown-hours" },
    { key: "minutes", value: pad(t.m), label: "Dakika", testid: "countdown-minutes" },
    { key: "seconds", value: pad(t.s), label: "Saniye", testid: "countdown-seconds" },
  ];

  return (
    <section
      id="geri-sayim"
      data-testid="countdown-section"
      className="relative overflow-hidden bg-surface/50 py-32 md:py-44"
    >
      <Mandala className="pointer-events-none absolute left-1/2 top-1/2 h-[120vh] w-[120vh] -translate-x-1/2 -translate-y-1/2 animate-spin-slow text-henna/15" />

      <div className="relative z-10 mx-auto max-w-6xl px-6 text-center md:px-10">
        <Reveal>
          <p className="mb-3 font-sans text-xs uppercase tracking-[0.35em] text-gold">
            O güne kalan
          </p>
          <p className="mb-8 font-serif text-3xl italic text-cream md:text-4xl">
            15 Kasım · 19:00
          </p>
          <Vine className="mx-auto mb-14 h-8 w-72 max-w-full text-gold/50" />
        </Reveal>

        <Reveal delay={0.15}>
          <div className="flex items-start justify-center divide-x divide-line/60">
            {units.map((u) => (
              <div key={u.key} className="px-4 md:px-10" data-testid={u.testid}>
                <div className="font-serif text-6xl leading-none text-cream md:text-8xl lg:text-9xl">
                  {u.value}
                </div>
                <div className="mt-4 font-sans text-[0.6rem] uppercase tracking-[0.3em] text-sand md:text-xs">
                  {u.label}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
